export default __webpack_public_path__ + "static/media/20-Serenity.dc08588b.jpeg";